module.exports = __webpack_public_path__ + "img/c3-tit2.b77b7710.png";